import { IData } from '@ysfe/request'
import { StoreModule } from '@ysfe/store'
import VueRouter, { Route } from 'vue-router'

import Apis from '@/apis'
import { apis, router } from '@/define'

import Store from '.'

/** store module 抽象类 */
export abstract class BaseModule<T extends IData> extends StoreModule<Store, T> {
    /** 接口集合 */
    get $apis(): Apis {
        return apis
    }

    /** 路由集合 */
    get $router(): VueRouter {
        return router
    }

    /** 当前路由 */
    get $route(): Route {
        return router.currentRoute
    }
}
